import React, { ComponentType } from 'react';
import { Route } from 'react-router';
import { Footer } from '../Footer';
import { useUser } from '../../helpers/customHooks';
import AuthService from '../../services/AuthService';
import { EmailVerificationPage, NotFoundPage } from '../../pages';
import { LoadingFullScreen } from '../Loading/Loading';

export interface FooterRouteProps {
  Component: ComponentType;
  path?: string;
  exact?: boolean;
  default?: boolean;
  margin?: boolean;
}

const ProtectedFooterRoute: React.FC<FooterRouteProps> = ({ Component, margin, ...rest }) => {
  const user = useUser();
  const loggedIn = AuthService.loggedIn();

  if (!loggedIn) return <NotFoundPage />;

  if (!user) {
    return (
      <div style={{ minHeight: '100vh' }}>
        <LoadingFullScreen />
      </div>
    );
  }

  if (!user.verified) return <EmailVerificationPage />;

  return (
    <Route {...rest}>
      <Component {...rest} />
      <Footer margin={margin} />
    </Route>
  );
};

export default ProtectedFooterRoute;
